import { createSlice } from "@reduxjs/toolkit";
import { getAdminAnalyticsThunk } from "../thunks/analyticsThunk";

const initialState = {
    stats: null,
    loading: false,
    error: null
};

const analyticsSlice = createSlice({
    name: "analytics",
    initialState,
    reducers: {
        resetAnalytics: (state) => {
            state.stats = null;
            state.loading = false;
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAdminAnalyticsThunk.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getAdminAnalyticsThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.stats = action.payload?.data;
                state.error = null;
            })
            .addCase(getAdminAnalyticsThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || "Something went wrong";
            });
    }
});

export const { resetAnalytics } = analyticsSlice.actions;
export default analyticsSlice.reducer;
